export const messages = {
  configurePageTitle: 'Configure Challenge',
  updatePageTitle: 'Update Challenge',
  subtitle:
    'Incentivize repeat visits by awarding benefits for purchase behavior over multiple transactions',
  resetProgressDialogTitle: 'Are you sure?',
  resetProgressDialogMessage: 'This change will reset progress for all members',
  resetProgressDialogConfirmButtonText: 'Confirm',
};
